export interface TokenPairResponse {
  refresh: string;
  access: string;
}

export interface TokenObtainRequest {
  username: string;
  password: string;
}

export interface TokenRefreshRequest {
  refresh: string;
}

export interface TokenAccessResponse {
  access: string;
}

export interface EnvelopeResponse<T> {
  code: number;
  status: string;
  message: string;
  data: T | null;
}

export interface UserRegistration {
  username: string;
  email: string;
  password: string;
  identificacion?: string;
}

export interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

// ========== USER MANAGEMENT TYPES ==========

export interface User {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  is_active: boolean;
  is_staff: boolean;
  is_superuser: boolean;
  date_joined: string;
  groups: Group[];
  whatsapp_roles: WhatsAppRole[];
  profile?: UserProfile;
}

export interface WhatsAppRole {
  id: number;
  rol: string;
  rol_display: string;
  assigned_at: string;
  assigned_by: number | null;
}

export const WHATSAPP_ROLE_CHOICES = [
  { value: 'support', label: 'Soporte' },
  { value: 'deliveries', label: 'Entregas' },
  { value: 'assistance', label: 'Asistencia' },
  { value: 'development', label: 'Desarrollo' },
  { value: 'sales', label: 'Ventas' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'other', label: 'Otro' },
] as const;

export interface AssignWhatsAppRoleRequest {
  user_id: number;
  rol: string;
  action: 'assign' | 'unassign';
}

export interface UserProfile {
  id?: string;
  identificacion?: string;
  razon_social?: string;
  nombre_comercial?: string;
  direccion?: string;
  telefono?: string;
}

export interface Group {
  id: number;
  name: string;
  permissions?: number[];
}

export interface UserCreateRequest {
  username: string;
  email: string;
  password: string;
  first_name?: string;
  last_name?: string;
  is_staff?: boolean;
  groups?: number[];
}

export interface UserUpdateRequest {
  username?: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  is_active?: boolean;
  is_staff?: boolean;
  groups?: number[];
}

export interface ActivateUserRequest {
  is_active: boolean;
}

export interface AssignPermissionsRequest {
  user_id?: number;
  group_id?: number;
  permissions: number[];
}

export interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}